import React, { createContext, useState, useContext, useMemo, useEffect } from "react";
import { generateCorrelativeHash } from "../utils/textUtils";
import axios from "axios";

const ClientContext = createContext();

export function ClientProvider({ children, skipInitialCheck = false }) {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [uuid, setUuid] = useState(null);
    const [isAuthLoading, setIsAuthLoading] = useState(true);

    useEffect(() => {
        if (skipInitialCheck) {
            // Don't perform the automatic auth check on initial mount (useful for login routes)
            setIsAuthLoading(false);
            return;
        }
        
        //checkUser();
        setIsAuthLoading(false);
    }, [skipInitialCheck]);

    // Memoizar el valor del context para evitar re-renders innecesarios
    const contextValue = useMemo(
        () => ({ user, setUser, token, setToken, uuid, setUuid }),
        [user, token, uuid]
    );

    return (
        <ClientContext.Provider value={contextValue}>
            {!isAuthLoading && children}
        </ClientContext.Provider>
    );
}

export function useAuth() {
    return useContext(ClientContext);
}
